// extracted by mini-css-extract-plugin
module.exports = {"baseRoute_searchBar":"styles_baseRoute_searchBar__3rgHz","baseRoute-table-wrapper":"styles_baseRoute-table-wrapper__1J-Vj","baseRoute_header":"styles_baseRoute_header__2P6GB"};